export default __webpack_public_path__ + "static/media/avatar-02.9cad25c6.png";